export default __webpack_public_path__ + "media/images/svg/ico-pensions-b61d706d66920e6d0084c7fbd157fb71.svg";